<template>
  <!-- Full disclaimer: info Message with the shared AI-generated disclaimer text -->
  <Message
    v-if="variant === 'disclaimer'"
    severity="info"
    :closable="false"
    :class="['w-full', props.class]"
  >
    <i class="pi pi-info-circle mr-2" />{{ $t('shared.ai_disclaimer') }}
  </Message>

  <!-- Compact tag: small chip flagging AI-authored content -->
  <Tag
    v-else
    icon="pi pi-sparkles"
    :value="$t('shared.ai_generated')"
    severity="info"
    v-tooltip.top="$t('shared.ai_disclaimer')"
    :class="['!text-[0.75rem] !py-0.5 !px-2 !rounded-full', props.class]"
  />
</template>

<script setup lang="ts">
import Message from 'primevue/message'
import Tag from 'primevue/tag'

/**
 * Consistent AI-generated label (AI Act Art. 50(2)).
 * - `tag` (default): compact chip placed near AI-authored content, tooltip carries the full disclaimer.
 * - `disclaimer`: full info banner with the shared disclaimer text.
 * Wording comes from the single shared `shared.ai_generated` / `shared.ai_disclaimer` i18n keys.
 */
const props = withDefaults(
  defineProps<{
    variant?: 'tag' | 'disclaimer'
    class?: string
  }>(),
  { variant: 'tag', class: '' },
)
</script>
